import { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { loginSchema } from './authSchemas';
import apiServices from '../../services/service';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAppAuth } from '../../auth/appAuthContext';
import { tokenManager } from '../../auth/tokenManager';

const LoginBox = ({ onSignup, onForgot }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });
  const { login } = useAppAuth();
  const [showPassword, setShowPassword] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleLoginByDB = async (values) => {
    try {
      const response = await apiServices.loginByDB(values);
      // if (response?.status === 200 && response?.data?.accessToken) {
      //   tokenManager.setToken(response?.data?.accessToken);
      //   tokenManager.setLoginType("db");
      //   // 👇 pass username into context
      //   login("db", {
      //     username: values.username,
      //   });
      //   toast.success("Login successful");
      //   navigate('/dashboard');
      //   return;
      // }

      if (response?.status === 200 && response?.data?.accessToken) {
        tokenManager.setLoginType("db");
        tokenManager.setTokens(
          response.data.accessToken,
          response.data.refreshToken
        );

        login("db", { username: values.username });

        navigate("/dashboard");
        toast.success("Login successful");
      }
    } catch (error) {
      console.log("LOGIN ERROR:", error);

      // 🔥 extract backend error safely
      const apiMessage =
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        error?.response?.data?.title ||
        "Login failed. Please try again";

      toast.error(apiMessage);
    }
  };

  const handleForgotPassword = () => {
    // console.log('Forgot password clicked');
    navigate('/forgotPassword');
  };

  const handleSignUp = () => {
    navigate('/signup');
  };

  return (
    <div className="loginBox">
      <Formik
        initialValues={{ username: '', password: '' }}
        validationSchema={loginSchema}
        onSubmit={handleLoginByDB}
      >
        {({ errors, touched }) => (
          <Form className="login-card">
            <Field
              name="username"
              placeholder="Username"
              className={errors.username && touched.username ? 'errorField' : ''}
            />
            <ErrorMessage name="username" component="div" className="errorMessage" />

            <div className="password-container">
              <Field
                name="password"
                type={showPassword ? 'text' : 'password'}
                // type="password"
                placeholder="Password"
                className={errors.password && touched.password ? 'errorField' : ''}
              />
              <span className="eye-icon" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a21.77 21.77 0 0 1 5.06-5.94" />
                    <path d="M1 1l22 22" />
                    <path d="M9.53 9.53A3.5 3.5 0 0 0 12 15a3.5 3.5 0 0 0 2.47-5.47" />
                    <path d="M21 12s-4-8-11-8a10.94 10.94 0 0 0-3.06.44" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="black"
                    strokeWidth="3"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3.5" />
                  </svg>
                )}
              </span>
            </div>
            <ErrorMessage name="password" component="div" className="errorMessage" />

            {/* Remember + Forgot */}
            <div className="options">
              <label>
                <Field type="checkbox" name="rememberMe" /> Remember Me
              </label>

              <span className="link" onClick={onForgot}>
                Forgot your password?
              </span>
            </div>

            {/* Login Button */}
            <button type="submit" className="login-btn">
              Login
            </button>

            {/* Register */}
            {/* <p className="signup-text">
              Don’t have an account?{' '}
              <span className="link" onClick={onSignup}>
                Register
              </span>
            </p> */}
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default LoginBox;
